import { default as locales } from './locales.json'
import { default as global } from './global.json'
import { default as routes } from './routes.json'
import { default as Home } from './home.json'
import { default as products } from './products/index'
import { default as Consulting } from './consulting.json'
import { default as Accessibility } from './accessibility.json'
import { default as Security } from './security.json'
import { default as TermsOfUse } from './terms-of-use.json'
import { default as PrivacyPolicy } from './privacy-policy.json'
import { default as RequestDemo } from './request-demo.json'
import { default as ContactUs } from './contact-us.json'
import { default as BecomePartner } from './become-partner.json'
import { default as AboutUs } from './about-us.json'
import { default as Blog } from './blog.json'
import { default as BlogPost } from './blog-post.json'
import { default as Careers } from './careers.json'
import { default as Donates } from './donates.json'
import { default as MediaArticles } from './media-articles.json'
import { default as MediaPost } from './media-post.json'
import { default as img } from './img.json'
import { default as hellohr } from './hellohr.json'
import { default as Feedback } from './feedback.json'

export default {
  ...global,
  locales,
  routes,
  Home,
  products,
  Consulting,
  Accessibility,
  Security,
  TermsOfUse,
  PrivacyPolicy,
  RequestDemo,
  ContactUs,
  BecomePartner,
  AboutUs,
  Blog,
  BlogPost,
  Careers,
  Donates,
  MediaArticles,
  MediaPost,
  img,
  hellohr,
  Feedback
}



// WEBPACK FOOTER //
// ./src/translations/fr/index.js